// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/block-slider.scss
// module id = 141
// module chunks = 8